export const guidance = `<p>Coming soon</p>`;
export const chapsPayments = `<p>Coming soon</p>`;
export const bacsPayments = `<p>Coming soon</p>`;
export const fasterPayments = `<p>Coming soon</p>`;
export const sepaCreditTransfer = `<p>Coming soon</p>`;
export const internationalPayments = `<p>Coming soon</p>`;
export const interGroupTransfers = `<p>Coming soon</p>`;
export const bacsPaymentsSDSC = `<p>Coming soon</p>`;
export const multipleBacsPayments = `<p>Coming soon</p>`;
export const fasterPaymentsSDSC = `<p>Coming soon</p>`;
export const multipleFasterPayments = `<p>Coming soon</p>`;
export const template = `<p>Coming soon</p>`;






// WEBPACK FOOTER //
// ./src/components/content/fileImports.ts